import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';

import { isInternalUser, isPermissionError, isSSRError } from '../components/analyticsUtils.ts';
import type { ContentAnalyticsViewersUnifiedQuery as GraphqlQueryData } from '../queries/__types__/ContentAnalyticsViewersUnifiedQuery.ts';

export const useHideByline = (
	loading: boolean,
	data?: GraphqlQueryData,
	error?: ApolloErrorInterop,
): boolean => {
	return loading || isSSRError(data, error) || isPermissionError(error) || !isInternalUser(data);
};
